import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ColumnClassNamesType from 'propTypes/columnClassNamesType';
import FontAwesome from 'react-fontawesome';

const ExpanderCell = ({ expanded, setExpanded, columnClassNames }) => {
  const className = classNames(
    'contact-list-react-type-icon',
    'contact-list-row-expander',
    columnClassNames
  );

  return (
    <td className={className}>
      <button
        type='button'
        className={classNames('contact-list-react-expand-row', { expanded, collapsed: !expanded })}
        onClick={() => setExpanded(!expanded)}
      >
        <FontAwesome name={expanded ? 'caret-down' : 'caret-right'} />
      </button>
    </td>
  );
};

ExpanderCell.propTypes = {
  expanded: PropTypes.bool.isRequired,
  setExpanded: PropTypes.func.isRequired,
  columnClassNames: ColumnClassNamesType
};
ExpanderCell.defaultProps = {
  columnClassNames: ''
};

export default ExpanderCell;
